import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 设备分类列表数据
    getclassification({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/EquipmentClass/GetTreeGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存设备属性
    SaveDeviceproperties({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/EquipmentProperty/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除设备属性
    DeleteDeviceproperties({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/EquipmentClass/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取单位列表数据
    GetAttributetype({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsData/GetSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取设备分类属性列表
    GetListForEquipmentClassProperty({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/Equipment/EquipmentClass/GetListForEquipment_Class_Property_R', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存设备分类
    SaveDeviceClass({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('/Equipment/EquipmentClass/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除设备分类
    DeleteDeviceClass({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('/Equipment/EquipmentClass/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 给设备分类配置属性
    setEquipmentClassAttribte({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('/Equipment/EquipmentClass/SubmitFormExt', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetGridJsonForAllocate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/Equipment/EquipmentProperty/GetGridJsonForAllocate', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    deleteEquipmentClassProperty({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('/Equipment/EquipmentClass/Equipment_Class_Property_RDelete', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
